import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { formatString } from "@/core/utils/helpers";
import { ORGANIZATION_API_PATH } from "@/modules/Organization/constants";
import { ENTITY_BULK_ASSIGNMENT_API_PATHS } from "../constants";
import {
  IBulkUpdateAssignmentPayload,
  IGetOrganizationUsersParams,
} from "../types";

class EntityBulkAssignmentService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getOrganizationUsers(
    organizationId: string,
    params: IGetOrganizationUsersParams,
  ): Promise<ICoreResponse> {
    return this.restClient.get(
      formatString(
        ORGANIZATION_API_PATH.GET_ORGANIZATION_USERS,
        organizationId,
      ),
      params,
    );
  }

  public bulkUpdateAssignment(
    organizationId: string,
    body: IBulkUpdateAssignmentPayload,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      formatString(
        ENTITY_BULK_ASSIGNMENT_API_PATHS.BULK_UPDATE_ASSIGNMENT,
        organizationId,
      ),
      body,
    );
  }
}

export default EntityBulkAssignmentService;
